import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import VisitorCounter from './VisitorCounter';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinkClass = ({ isActive }) =>
    `block px-4 py-2 rounded-md text-base font-medium transition ${
      isActive
        ? 'text-white bg-blue-600 dark:bg-blue-500'
        : 'text-gray-700 dark:text-white hover:text-blue-600 dark:hover:text-blue-400'
    }`;

  return (
    <nav className="bg-white border-b border-gray-200 dark:bg-gray-900">
      <div className="max-w-screen-xl mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo */}
        <NavLink to="/" className="flex items-center space-x-3">
          <img
            src="https://flowbite.com/docs/images/logo.svg"
            alt="Logo"
            className="h-8"
          />
          <span className="text-2xl font-semibold dark:text-white">
            EmpowerHer
          </span>
        </NavLink>

        {/* Desktop Nav Menu */}
        <div className="hidden md:flex items-center space-x-6">
          <NavLink to="/" className={navLinkClass}>
            Home
          </NavLink>
          <NavLink to="/about" className={navLinkClass}>
            About
          </NavLink>
          <NavLink to="/contact" className={navLinkClass}>
            ContactUs
          </NavLink>
          <NavLink to="/involve" className={navLinkClass}>
            Get Involved
          </NavLink>
          <NavLink to="/donate" className={navLinkClass}>
            Donate
          </NavLink>
          <VisitorCounter />
        </div>

        {/* Hamburger Button */}
        <button
          className="md:hidden text-gray-500 dark:text-gray-400"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white dark:bg-gray-900 px-4 py-2 space-y-2 border-t border-gray-200">
          <NavLink to="/" className={navLinkClass} onClick={() => setIsOpen(false)}>
            Home
          </NavLink>
          <NavLink to="/about" className={navLinkClass} onClick={() => setIsOpen(false)}>
            About
          </NavLink>
          <NavLink to="/contact" className={navLinkClass} onClick={() => setIsOpen(false)}>
            ContactUs
          </NavLink>
          <NavLink to="/involve" className={navLinkClass} onClick={() => setIsOpen(false)}>
            Get Involved
          </NavLink>
          <NavLink to="/donate" className={navLinkClass} onClick={() => setIsOpen(false)}>
            Donate
          </NavLink>
          <VisitorCounter />
        </div>
      )}
    </nav>
  );
};

export default Navbar;
